<template>
  <div v-if="!isAuthenticated">
    <p class="text-muted">Access to content contained on this webpage is subject to you agreeing to the Goalbook <a href="https://goalbookapp.com/terms/" target="_blank">Terms of Use</a>. By continuing to access and view the content on this webpage you are agreeing to the Terms of Use. If you do not agree to the Terms of Use, you must immediately close this webpage and discontinue any further access to it.</p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'TermsOfUseFooter',
  computed: {
    ...mapGetters('user', ['isAuthenticated'])
  }
}
</script>

<style scoped>
p {
  max-width: 900px;
  margin-top: 36px;
  font-size: 12px;
}
</style>
